export default "__VITE_ASSET__DSA_B0HO__"